/*
 * @Author: 吴文洁
 * @Date: 2019-12-21 11:00:41
 * @LastEditors: 吴文洁
 * @LastEditTime: 2020-12-30 17:46:41
 * @Description: 
 */

import { MIN_NUM, MAX_NUM, DECIMAL_MIN_NUM, DECIMAL_MAX_NUM } from '@/common/constants';

/**
 * 
 * @param money 金额
 * @param multiple 倍数
 * @param isDivisior 是否进行除法运算
 */

export function formatMoney(
  money: number,
  multiple: number,
  isDivisior?: boolean
): number {
  if (!isDivisior) {
    return Number((money * multiple).toFixed(0));
  }
  return Number((money / multiple).toFixed(2));
}

/**
 * @param num 输入的数值
  格式化整数位和小数位，最多只能输入五位整数和两位小数
 */
export function formatDecimal (num: number | string) {
  const priceStr = num.toString().split('.');
  const interge = priceStr[0].length > 5 ? priceStr[0].substring(0, 5) : priceStr[0];
  const decimal = priceStr[1] && priceStr[1].length > 2 ? priceStr[1].substring(0, 2) : priceStr[1];

  return decimal ? `${interge}.${decimal}` : interge;
}

/**
 * 
 * @param value 金额
 * @param hasDecimal 是否需要保留小数
 */

export function resolveBoundaryValue(value: number, hasDecimal: boolean = false) {
  if (hasDecimal) {
    if (value < DECIMAL_MIN_NUM) {
      return DECIMAL_MIN_NUM;
    }
    if (value > DECIMAL_MAX_NUM) {
      return DECIMAL_MAX_NUM;
    }

    if (DECIMAL_MIN_NUM <= value && DECIMAL_MAX_NUM >= value) {
      const _value = Number(value).toFixed(2);
      return _value;
    }
  } else {
    if (value < MIN_NUM) {
      return MIN_NUM;
    }
    if (value > MAX_NUM) {
      return MAX_NUM;
    }

    if (MIN_NUM <= value && MAX_NUM >= value) {
      const _value = Math.round(value)
      return _value;
    }
  }
  return value;
}